import React from "react";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import AccountDetailLeftSideContent from "./account-detail-left-side-content/AccountDetailLeftSideContent";
import { useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { setIsHidden } from "store/header";
import { useDispatch } from "react-redux";
import { useAppSelector } from "store/store";
export default function AccountDetailLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const { isHidden } = useAppSelector((state) => state.header);

  return (
    <div className="flex">
      <div className={`sticky ${location.pathname === "/accuont-tools" ? "top-0 " : "top-[80px] "}  left-0 h-[calc(100vh-80px)] z-0`}>
        <AccountDetailLeftSideContent />
      </div>
      <div className="flex justify-center w-full p-4 dark:bg-background z-0">
        <ScrollArea className="w-full">
          <div className="">{children}</div>
          <div
            className={`lg:hidden  fixed bottom-3 right-3  flex items-center justify-center
                  w-10 h-10 rounded-full shadow-lg shadow-blue-500/50 transition-all duration-300 z-50 
                  bg-gradient-to-r bg-primary text-white hover:scale-110 hover:opacity-90  `}
            onClick={() => {
              dispatch(setIsHidden(!isHidden));
            }}
          >
            <button className="outline-none focus:border-none transition-transform duration-700 ease-in-out flex items-center justify-center">
              <span className={`inline-block transition-transform duration-700 ease-in-out ${isHidden ? "rotate-0 opacity-100" : "rotate-180 opacity-80"}`}>
                {isHidden ? <X /> : <Menu />}
              </span>
            </button>
          </div>
          <ScrollBar orientation="vertical" />
        </ScrollArea>
      </div>
    </div>
  );
}
